import { Helmet } from "react-helmet-async";
import MineBody from "./components/MineBody";

function MineGame() {
 
  return (
    <>
      <Helmet>
        <title>
          Mine Game – Play & Win | 10% Welcome Bonus + 10% on Every Deposit
        </title>
        <meta
          name="description"
          content="Play the Mine Game on Henwin and get a 10% bonus on your first recharge — plus 10% bonus on every deposit. Enjoy fast gameplay and win big!"
        />
        <meta
          name="keywords"
          content="mine game, online mine game, play mine game, henwin mine game, mine & win, 10% welcome bonus, deposit bonus, bonus games online, instant win games, online gaming bonus"
        />
      </Helmet>
      <MineBody />
    </>
  );
}

export default MineGame;
